import {
  Modal as MuiModal,
  Stack,
  SxProps,
  Typography
} from "@mui/material";
import {
  alpha,
  styled,
  useTheme
} from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { CustomRegex } from "../../utils/regex";


const StyledModal = styled(MuiModal)(({ theme }) => {
  const contentWidth = "20rem";
  const modalWidth = "25rem";
  
  return {

    backdropFilter:"blur(20px)",
    backgroundColor: theme.customColors.backgroundCard,
    borderRadius:theme.spacing(1),
    boxShadow: "24px",
    height: "fit-content",
    left: "50%",
    maxHeight: "90vh",
    overflow: "auto",
    padding: "1.5rem",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: modalWidth,
    zIndex: "1600 !important",
    ".MuiModal-backdrop":{
      backdropFilter:"none",
      background:"none",
      borderRadius:theme.spacing(1)

    },

    "p": {
      maxWidth: contentWidth,
      overflowWrap:"break-word"
    }
  };});

export function Modal({
  description,
  onClose,
  open,
  title,
  sxStyle,
  icon,
  centerText = false
}: {
  description: string
  onClose: () => void
  open: boolean
  title: string,
  sxStyle?: SxProps,
  icon?: JSX.Element,
  centerText?: boolean
}) {
  const { t } = useTranslation();
  const { pathname, state:routerState } = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();

  const currentLocation = CustomRegex.matchDirectChild(pathname, "signup");

  return (
    <StyledModal
      sx={ sxStyle }
      aria-labelledby="modal"
      open={ open }
      onClose={ onClose }
      slotProps={ {
        backdrop: {
          sx: {
            background: alpha(theme.customColors.backgroundPrimary, 0.95),
            border: `0.125rem solid ${theme.customColors.border}`,
            boxShadow: `0 0 1rem 0rem ${alpha(theme.customColors.backgroundPrimaryCta, 0.95)},
0 0 2rem 0.25rem ${alpha(theme.customColors.backgroundPrimary, 0.95)}`
          }
        }
      } }
    >
      <Stack
        alignItems="center"
        gap={ "1rem" }
        sx={ { "&:focus-visible": {
          outline: "none"
        } } }
      >
        { icon && icon }
        <Stack
          alignItems="center"
          gap={ "0.5rem" }
        >
          <Typography
            aria-labelledby="modal-modal-title"
            color={ theme.customColors.exploreCardText }
            variant="h2"
            fontSize="1.5rem"
            lineHeight="1.8rem"
            fontWeight={ 600 }
            textAlign={ centerText ? "center" : undefined }
          >
            { title }
          </Typography>
          { description &&
            <Typography
              aria-describedby="modal-modal-description"
              color={ theme.customColors.exploreCardText }
              fontSize="0.875rem"
              lineHeight="1rem"
              sx={ { whiteSpace: "pre-line" } }
              textAlign={ centerText ? "center" : undefined }
            >
              { description }
            </Typography>
          }
        </Stack>
        { /* TODO componente modale da dinamicizzare, onClick, label del bottone e onClose  */ }
        <ButtonDigited
          typology="primary"
          aria-labelledby="modal-modal-continue"
          text={ t("continue") }
          onClick={ ()=> {
            onClose();
            if(
              ( currentLocation === "job" ||
            currentLocation === "profession" ||
            currentLocation === "skills"     ||
            currentLocation === "capabilities" ||
            currentLocation === "preferences")
            ){
              if(routerState.first){
                navigate("/logout");
              }
              else {
                navigate("/profile");
              }

            }

          } }
          sx={ {
            ":hover": { backgroundColor: alpha(theme.customColors.backgroundPrimaryCta, 0.9) }
          } }
        />
      </Stack>
    </StyledModal>
  );
}
